<script setup>

</script>

<template>
  <!-- 页脚 -->
  <footer>
    <div class="footer-content">
      <div class="footer-section">
        <h4>关于我们</h4>
        <p>© 2025 兮颜网络 版权所有</p>
        <p><a class="" href="https://beian.miit.gov.cn/" target="_blank">豫ICP备2021031236号</a></p>
      </div>

<!--      <div class="footer-section">-->
<!--        <h4>关注我们</h4>-->
<!--        <div class="social-links">-->
<!--          <a href="#">微信</a>-->
<!--          <a href="#">微博</a>-->
<!--        </div>-->
<!--      </div>-->
      <div class="footer-section">
        <h4 >联系方式</h4>
        <img style="width: 100px;height:100px;" src="@/assets/img.png" alt="">
      </div>
    </div>
  </footer>
</template>

<style scoped>
/* 页脚样式 */
footer {
  background-color: #2c3e50;
  color: white;
  padding:0.5rem 20% 0.5rem;
  width: 100%;
  box-sizing: border-box;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}
.footer-section{
  text-align: center;
}
.footer-section h4 {
  margin-bottom: 1rem;
  font-size: 1.2rem;
}
.footer-section  a{
  color: #fff;
  text-decoration: none;
}

.social-links a {
  color: white;
  text-decoration: none;
  margin-right: 1rem;
}

.social-links a:hover {
  color: #3498db;
}

.copyright {
  text-align: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
